import React from 'react';
import SignUpModal from 'login/components/SignUp/SignUpModal.jsx';
import SignInModal from 'login/components/SignIn/SignInModal.jsx';
import ForgetPasswordModal from 'login/components/ForgetPassword/ForgetPasswordModal.jsx';
import ResetPasswordModal from 'login/components/ResetPassword/ResetPasswordModal.jsx';
import SaveConfirmationModal from 'login/components/SaveConfirmation/SaveConfirmationModal.jsx';

const Modals = () => {
    return (
        <>
            <SignUpModal />
            <SignInModal />
            <ForgetPasswordModal />
            <ResetPasswordModal />
            <SaveConfirmationModal />
        </>
    );
};

Modals.displayName = 'Modals';

export default Modals;
